module.exports = __webpack_public_path__ + "static/media/guide_step7.d40a033d.png";